<script lang="ts">
    import { setContext } from "svelte";    
    import { readable } from "svelte/store";
    import { ListGroup, ListGroupItem } from "sveltestrap";
    import type { FormInstance } from "../../Model/FormInstance";
    import type { FormMember } from "../../Model/FormMember";
    import MembersListItem from "./MembersListItem.svelte";

    export let instance: FormInstance;

    setContext('getInstance', () => instance);
   
    const members = readable([], set => instance.membersReadable.subscribe((members: FormMember[]) => {
        //Colocamos al propietario en la primera posición del array
        const sorted = [
            members.find(({ isOwner }) => isOwner),
            ...members.filter(({ isOwner }) => !isOwner),
        ];
        set(sorted);
    }));

</script>

<ListGroup>
    {#each $members as member}
    <ListGroupItem>
        <MembersListItem {member} />
    </ListGroupItem>
    {/each}
</ListGroup>
